// extracted by mini-css-extract-plugin
export default {"inputBlock":"BoxInput_inputBlock__uc21Y","iconBox":"BoxInput_iconBox__qa9Ut","icon":"BoxInput_icon__hATmf","input":"BoxInput_input__-VmJi"};